import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import AddMemberToOrder from '@components/assign-team-member/AddMemberToOrder';
import { toastError } from '@components/Toast';
import CommonImage from '@components/CommonImage';

import OrderInfoDetails from '@features/order/components/orderInfo/OrderInfoDetails';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { fetchOrderDetailsInfo } from '@store/orders/actions';
import { getOrderDetailsInfo } from '@store/reducers';

import ApiClient from '@lib/apiClient';

import { changeDateFormat } from '@utils/Util';

const OrderDetails = () => {
	const [orderDetailsInfo, setOrderDetailsInfo] = useState(null);
	const [, setStylesCount] = useState(0);
	const { id } = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const orderDetailsStore = useSelector(getOrderDetailsInfo);

	useEffect(() => {
		dispatch(fetchOrderDetailsInfo(id));
	}, [id]);

	useEffect(() => {
		setOrderDetailsInfo(orderDetailsStore);
	}, [orderDetailsStore]);

	useEffect(() => {
		if (orderDetailsInfo?.approvalStatus === 'APPROVED') {
			navigate(`/orders/view/${orderDetailsInfo?.id}`, { replace: true });
			setOrderDetailsInfo(null);
		}
	}, []);

	const onApprove = async () => {
		try {
			dispatch(openLoader());
			const { data } = await ApiClient.POST('getOrderDetails', {}, `${id}/approve/buyer-request`);
			dispatch(closeLoader());
			if (data) {
				navigate(`/orders/view/${id}`, { replace: true });
			}
		} catch ({ response }) {
			dispatch(closeLoader());
			if (response && response.data && response.data.message) {
				toastError(response.data.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	const onCancel = async () => {
		try {
			dispatch(openLoader());
			const { data } = await ApiClient.POST('getOrderDetails', {}, `${id}/cancel/buyer-request`);
			dispatch(closeLoader());
			if (data) {
				navigate('/buyer-requests');
			}
		} catch ({ response }) {
			dispatch(closeLoader());
			if (response && response.data && response.data.message) {
				toastError(response.data.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	return (
		<div>
			<div className="top-header bg-white">
				<div className="filter-container-top pt-2 pb-2 bg-gray">
					<div className="filters">
						<div className="sample-full-status">
							<ul className="common-list-component mb-2">
								<li>
									<CommonImage
										className="cursor-pointer"
										src={`${process.env.PUBLIC_URL}/icons/back-arrow-gray.svg`}
										alt="back"
										onClick={() => navigate(-1)}
									/>
									<span className="gray_dark_01 ml-2">
										{orderDetailsInfo?.title || orderDetailsInfo?.name}
									</span>
								</li>
								<li>
									<span>{orderDetailsInfo?.orderRefNumber} </span>
								</li>

								<li>
									<span>
										{changeDateFormat(
											orderDetailsInfo?.startDate,
											'DD/MM/YYYY',
											'Do MMM'
										)}
									</span>
								</li>
							</ul>
						</div>
						<div className="ml-2 mb-3 brand-and-logo d-flex justify-content-between align-items-center">
							<div>
								{orderDetailsInfo?.brandResponse ? (
									<span className="brand-common-design mt-3">
										{orderDetailsInfo?.brandResponse?.name}
									</span>
								) : (
									''
								)}
							</div>
						</div>
					</div>
					<AddMemberToOrder
						orderId={orderDetailsInfo?.id}
						requestFrom="PENDING_REQUEST"
						isUserExist={!!orderDetailsInfo?.projectManagerResponse?.id}
					/>
					{orderDetailsInfo?.approvalStatus === 'PENDING' && (
						<div>
							<button className="button gray-outline size32 mr-3" onClick={onCancel}>
								<span>Cancel</span>
							</button>
							<button
								className="button approve size32 mr-3"
								onClick={onApprove}
								disabled={!orderDetailsInfo?.projectManagerResponse?.id}
							>
								<span>Approve</span>
							</button>
						</div>
					)}
					{orderDetailsInfo?.approvalStatus === 'CANCELLED' && (
						<span className="button gray-outline size32 mr-3">Cancelled</span>
					)}
				</div>
			</div>
			<div className="mt-3">
				{/* <OrderInfoDetails orderId={id} /> */}
				{orderDetailsInfo && orderDetailsInfo?.id && (
					<OrderInfoDetails
						orderId={orderDetailsInfo?.id}
						// orderCancelInfo={orderCancelInfo}
						// getOrderCancelInfo={getOrderCancelInfo}
						isDrafted={orderDetailsInfo?.isDrafted}
						setStylesCount={setStylesCount}
					/>
				)}
			</div>
		</div>
	);
};

export default OrderDetails;
